import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Test order',
    ordered_at: 'Ordered at:',
  },
  delivery_info: {
    info: 'Delivery info:',
  },
  order_note: {
    label: 'Order note:',
  },
  schedule_info: {
    pickup: 'Pickup',
    delivery: 'Delivery',
    room_service_location: {
      room_service: 'Room',
      table_service: 'Table',
    },
    wish_time: 'Desired time:',
    confirmed_time: 'Confirmed time:',
    driver_arrival_time: 'Driver pick-up time:',
    external_delivery: 'The order is delivered by an external driver from {{carrier}}',
  },
  products: {
    item: 'Item:',
  },
  discount_breakdown: {
    label: 'Discount',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Percentage off by total applied',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Percentage off by products applied',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Amount off by products applied',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Amount off by total applied',
    [OFFER_KIND.BOGO]: 'Bogo applied',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo half price applied',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Free item by products applied',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Free item by total applied',
    GiftCard: 'Gift card applied',
    Reward: 'Loyalty points applied',
    CashbackAccount: 'Loyalty points applied',
    PromoCodeComponent: 'Promo applied',
    Offer: 'Offer applied',
  },
  payment_breakdown: {
    price: 'Price:',
    subtotal: 'Subtotal',
    delivery_fee: 'Delivery fee',
    tips: 'Tip',
    processing_fee: 'Online service fee',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal fee',
    },
    tax: 'Taxes',
    total: 'Total',
    paid_amount: 'Amount paid',
    order_not_paid: 'Order has not yet been paid',
    order_paid_online: 'Already paid online',
    cash: 'Payment On Site',
    this_is_not_an_invoice: 'This is not an invoice',
  },
  delivery_qr_code: {
    scan: 'Scan & deliver with Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
